<template>
  <b-navbar-nav id="menu">
    <router-link tag="li" to="/device" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="sign" />
          <p>Mes supports</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/reports" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="file-signature" />
          <p>Je déclare</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/report-history" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="history" />
          <p>Mes déclarations</p>
        </div>
      </a>
    </router-link>
    <router-link tag="li" to="/documents" class="nav-item">
      <a class="nav-link">
        <div>
          <font-awesome-icon class="icon" icon="folder" />
          <p>Mes documents</p>
        </div>
      </a>
    </router-link>
  </b-navbar-nav>
</template>

<script>
export default {
  name: 'app-navbar-menu'
}
</script>



// WEBPACK FOOTER //
// src/components/navbar/app-navbar-menu.vue